import type {
  InstanceManagementState,
  InstanceSearchServiceConfig,
  MutationClass,
} from '../../../models'

export class SetSearchServiceConfigMutation implements MutationClass {
  static execute(
    this: void,
    state: InstanceManagementState,
    searchServiceConfig: InstanceSearchServiceConfig,
  ): void {
    state.searchServiceConfig = searchServiceConfig
  }
}
